export default __webpack_public_path__ + "static/media/first_place.85cda5b1.svg";